/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_CastInputs */

const en_fw_node_cast = /** @type {(inputs: Fw_Node_CastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cast`)
};

const zh_fw_node_cast = /** @type {(inputs: Fw_Node_CastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`声优`)
};

/**
* | output |
* | --- |
* | "Cast" |
*
* @param {Fw_Node_CastInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_cast = /** @type {((inputs?: Fw_Node_CastInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_CastInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_cast(inputs)
	return zh_fw_node_cast(inputs)
});
export { fw_node_cast as "fw.node.cast" }